import React from "react";

function ErrorNotFound() {
    return (
        < div >
            <h2>404 Error</h2>
            <p>Page Not Found</p>
        </div >
    )

}
export default ErrorNotFound;